<template>
    <section id="services" class="wrapper style2">
        <div class="inner">
            <header class="align-center">
                <p class="special">{{subTitle}}</p>
                <h2>{{header}}</h2>
            </header>
            <br />

            <div class="grid-style">
                <div v-for="service in services" :key="service.id">
                    <div class="box">
                        <div class="image fit">
                            <img :src="service.img" :alt="service.alt" />
                        </div>
                        <div class="content">
                            <header class="align-center">
                                <p>{{service.subTitle}}</p>
                                <h2 v-html="service.title"></h2>
                            </header>
                            <p>{{service.teaserDescription}}</p>
                            <footer class="align-center">
                                <a class="button alt" v-on:click="viewServiceDetail(service.id)">{{readMoreText}}</a>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
export default {
	props : {
		services : Array,
	},
    data() {
        return {
			header: 'SERVIÇOS',
			subTitle: 'Vamos resolver suas necessidades',
			readMoreText: "Ler Mais",
        }
	},
	methods : {
		viewServiceDetail : function(serviceId) {
            this.$parent.viewServiceDetail(serviceId);
		},
	}
}
</script>

<style scoped>
    #services .box {
        -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
    }
</style>